<!-- Sidebar Start -->
<nav id="sidebar" class="sidebar-main">
  <div class="sidebar-inner">

    <!-- Sidebar toggle -->
    <div class="sidebar-toggle-main">
      <button (click)="toggleSideBar()" id="sidebarCollapse" class="btn toggle-sidebar-btn">
        <i [ngClass]="isSidebarButtonToggled ? 'pi-angle-double-right' : 'pi-angle-double-left'" class="pi"></i>
      </button>
    </div>

    <!-- Sidebar Header / Logo -->
    <div class="sidebar-header">
      <a class="sidebar-logo-container" href="#">
        <img class="sidebar-logo" src="../../../assets/images/logos/vetrotech_tesca_logo.png" alt="logo" />
      </a>
    </div>

    <!-- Sidebar Menu List -->
    <div class="menubar">
      <ul class="list-unstyled components">

        <!-- Dashboard -->
        <li class="menu-item primary-list">
          <a routerLink="/dashboard" class="menulink" routerLinkActive="active">
            <span class="menu-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="16" height="16">
                <path d="M298.2 72.6C310.5 61.2 329.5 61.2 341.7 72.6L432 156.3L432 144C432 126.3 446.3 112 464 112L496 112C513.7 112 528 126.3 528 144L528 245.5L565.8 280.6C575.4 289.6 578.6 303.5 573.8 315.7C569 327.9 557.2 336 544 336L528 336L528 512C528 547.3 499.3 576 464 576L176 576C140.7 576 112 547.3 112 512L112 336L96 336C82.8 336 71 327.9 66.2 315.7C61.4 303.5 64.6 289.5 74.2 280.6L298.2 72.6zM304 384C277.5 384 256 405.5 256 432L256 528L384 528L384 432C384 405.5 362.5 384 336 384L304 384z"/>
              </svg>
            </span>
            <span class="menulink-text">Dashboard</span>
          </a>
        </li>

        <!-- Projects Group -->
        <li class="menu-group">
          <ul>
            <li class="menu-item Searching">
              <a routerLink="/projects" class="menulink searchText" routerLinkActive="active">
                <span class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M22,2H2A1,1,0,0,0,1,3V21a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V3A1,1,0,0,0,22,2ZM3,14V10H9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1h6v4ZM3,4H9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1h6V8H3ZM21,20H3V16H9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1h6Z"/>
                  </svg>
                </span>
                <span class="menulink-text">Projects</span>
              </a>
            <!-- </li>
            <li class="menu-item submenu-link"> -->
              <a routerLink="/projects/search" class="menulink searchIcon" routerLinkActive="active">
                <span class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22.41,22.41a1.974,1.974,0,0,1-2.82,0l-3.35-3.35a11.116,11.116,0,0,0,2.82-2.82l3.35,3.35A1.974,1.974,0,0,1,22.41,22.41Z"/>
                    <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,5a4,4,0,0,0-4,4,1,1,0,0,1-2,0a6.006,6.006,0,0,1,6-6,1,1,0,0,1,0,2Z"/>
                  </svg>
                </span>
                <!-- <span class="menulink-text">Search</span> -->
              </a>
            </li>
          </ul>
        </li>

        <!-- Tests Group -->
        <li class="menu-group">
          <ul>
            <li class="menu-item Searching">
              <a routerLink="/tests" class="menulink searchText" routerLinkActive="active">
                <span class="menu-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134.5 84.27" 
     fill="none" stroke="black" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" shape-rendering="geometricPrecision">
  <path d="M42.14.75C19.28.75.75,19.28.75,42.14s18.53,41.39,41.39,41.39h50.23c22.86,0,41.39-18.53,41.39-41.39S115.22.75,92.37.75h-50.23Z"/>
  <path d="M56.55,55.6c.48-1.81.75-3.95.75-6.46,0-12.83-11.59-15.93-15.41-23.47-2.77-5.47-.78-12.73-.78-12.73-1,0-12.03,8.06-7.71,25.35,0,0-6.3-2.4-5.75-10.49,0,0-9.63,9.59-9.63,21.47s9.39,21.96,19.45,21.96"/>
  <polyline points="86.86 46.81 93.22 52.56 103.01 38.18"/>
  <path d="M93.4,60.51c16-7.55,15.07-28.93,15.07-28.93,0,0-7.98-1.41-15.07-6.7-9.17,6.75-22.49,7.83-22.49,7.83,1.25,13.11,3.9,27.93,22.49,36.72,25.76-11.04,22.99-44.54,22.99-44.54,0,0-14.29-1.18-22.99-10.02-6.6,6.01-15.61,8.7-22.64,9.89-.22.04-.44.07-.66.11-1.03.17-2.02.3-2.94.41"/>
                  </svg>
                </span>
                <span class="menulink-text">Tests</span>
              </a>
            <!-- </li>
            <li class="menu-item submenu-link"> -->
              <a routerLink="/tests/search" class="menulink searchIcon" routerLinkActive="active">
                <span class="menu-icon">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M22.41,22.41a1.974,1.974,0,0,1-2.82,0l-3.35-3.35a11.116,11.116,0,0,0,2.82-2.82l3.35,3.35A1.974,1.974,0,0,1,22.41,22.41Z"/>
  <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,5a4,4,0,0,0-4,4,1,1,0,0,1-2,0a6.006,6.006,0,0,1,6-6,1,1,0,0,1,0,2Z"/>
</svg>
                </span>
                <!-- <span class="menulink-text">Search</span> -->
              </a>
            </li>
          </ul>
        </li>

        <!-- Certificates Group -->
        <li class="menu-group">
          <ul>
            <li class="menu-item Searching">
              <a routerLink="/certificates" class="menulink searchText" routerLinkActive="active">
                <span class="menu-icon">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" 
       fill="none" stroke="black" stroke-width="64" stroke-linecap="round" stroke-linejoin="round">
    <path d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM248 320C234.7 320 224 330.7 224 344C224 357.3 234.7 368 248 368L392 368C405.3 368 416 357.3 416 344C416 330.7 405.3 320 392 320L248 320zM248 416C234.7 416 224 426.7 224 440C224 453.3 234.7 464 248 464L392 464C405.3 464 416 453.3 416 440C416 426.7 405.3 416 392 416L248 416z"/>
  </svg>
</span>
                <span class="menulink-text">Certificates</span>
              </a>
            <!-- </li>
            <li class="menu-item submenu-link"> -->
              <a routerLink="/certificates/search" class="menulink searchIcon" routerLinkActive="active">
                <span class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22.41,22.41a1.974,1.974,0,0,1-2.82,0l-3.35-3.35a11.116,11.116,0,0,0,2.82-2.82l3.35,3.35A1.974,1.974,0,0,1,22.41,22.41Z"/>
                    <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,5a4,4,0,0,0-4,4,1,1,0,0,1-2,0a6.006,6.006,0,0,1,6-6,1,1,0,0,1,0,2Z"/>
                  </svg>
                </span>
                <!-- <span class="menulink-text ">Search</span> -->
              </a>
            </li>
          </ul>
        </li>

                       <!-- Combined search Group -->
        <li class="menu-group">
          <ul>
            <li class="menu-item">
              <a routerLink="/Search/combined-search-text" class="menulink" routerLinkActive="active">
                 <span class="menu-icon">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22.41,22.41a1.974,1.974,0,0,1-2.82,0l-3.35-3.35a11.116,11.116,0,0,0,2.82-2.82l3.35,3.35A1.974,1.974,0,0,1,22.41,22.41Z"/>
                  <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,5a4,4,0,0,0-4,4,1,1,0,0,1-2,0a6.006,6.006,0,0,1,6-6,1,1,0,0,1,0,2Z"/>
                </svg>
                </span>
                <span class="menulink-text">Construction Element Search</span>
              </a>
            </li>         
          </ul>
        </li>

         <!--full text search-->
        <li class="menu-group">
          <ul>
            <li class="menu-item">
              <a routerLink="/Search/full-text-search" class="menulink" routerLinkActive="active">
                <span class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22.41,22.41a1.974,1.974,0,0,1-2.82,0l-3.35-3.35a11.116,11.116,0,0,0,2.82-2.82l3.35,3.35A1.974,1.974,0,0,1,22.41,22.41Z"/>
                    <path d="M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm0,5a4,4,0,0,0-4,4,1,1,0,0,1-2,0a6.006,6.006,0,0,1,6-6,1,1,0,0,1,0,2Z"/>
                  </svg>
                </span>
                <span class="menulink-text">Full Text Search</span>
              </a>
            </li>
          </ul>
        </li>




      </ul>
    </div>

    <!-- User Account -->
    <div class="account-wrapper">
      <div class="dropdown">
        <div id="dropdownUserAccount" class="btn user-account-wrapper dropdown-toggle" role="button"
          data-bs-toggle="dropdown" aria-expanded="false">
          <div class="user-profile-details">
            <img class="profileIcon" src="../../assets/images/icons/profileIcon.png" alt="Profile Icon">
            <p class="user-name">{{ userAccount.name }}</p>
          </div>
        </div>
        <ul class="dropdown-menu" aria-labelledby="dropdownUserAccount">
          <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
        </ul>
      </div>
    </div>

    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <span class="f-logo"><img src="../../../assets/images/logos/vetrotech_sg_logo.png" alt="Logo" /></span>
    </div>

  </div>
</nav>
<!-- Sidebar End -->
